import { DataGrid } from '@mui/x-data-grid';
export const Table = (props: React.ComponentProps<typeof DataGrid>) => (
  <DataGrid
    sx={{
      '& .disabled-cell': {
        backgroundColor: 'rgb(245, 245, 245)',
        color: '#666',
        fontWeight: 'normal',
      },
    }}
    rowHeight={30}
    columnHeaderHeight={30}
    hideFooter
    disableRowSelectionOnClick
    disableColumnMenu
    disableColumnFilter
    disableColumnSelector
    disableDensitySelector
    disableColumnSorting
    disableColumnResize
    {...props}
  />
);
